import { getPlaceholderForEmptyString } from "../../../../utils/emptyStringCheck";
import { formatNumber } from "../../../../utils/numberFormatterUtil";

export const getFinanceDetails = ({
  revenue,
  cogs,
  grossProfit,
  terms,
}: {
  revenue: number;
  cogs: number;
  grossProfit: number;
  terms: string;
}) => [
  {
    label: "Total Revenue",
    value: `$${formatNumber(Number(revenue)?.toFixed(2))}`,
  },
  {
    label: "Current COGS",
    value: `$${formatNumber(Number(cogs)?.toFixed(2))}`,
  },
  {
    label: "Total Gross Profit",
    value: `$${formatNumber(Number(grossProfit)?.toFixed(2))}`,
  },
  {
    label: "Payment Terms",
    value: getPlaceholderForEmptyString(terms),
  },
];
